const TEMPLATES = [
  {
    name: 'Template: Name 1',
    key: 'TEMPLATE_NAME_1',
    id: 1
  },
  {
    name: 'Template: Name 2',
    key: 'TEMPLATE_NAME_2',
    id: 2
  },
  {
    name: 'Template: Name 3',
    key: 'TEMPLATE_NAME_3',
    id: 3
  }
];

export default TEMPLATES;
